var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalFireDepartment24DpFill1Wght300Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180-400q0-101.46 58.54-197.19t160.54-168.35q19.3-14.23 40.5-2.84 21.19 11.38 21.19 34.92v33.92q0 36.69 29.84 64.12Q520.46-608 561-608q17.77 0 34.42-6.92 16.66-6.92 30.58-19.77 8-8.08 18.96-9.42 10.96-1.35 20.42 5.88 53.77 42.31 84.2 105.19Q780-470.15 780-400q0 89.92-47.62 161.65Q684.77-166.62 609-131.54q19.31-21.31 30.15-48.46Q650-207.15 650-238q0-33.46-12.69-63.77-12.7-30.31-36.47-54.07L480-474.07 360.16-355.84q-24.39 24.38-37.27 54.19Q310-271.85 310-238q0 30.85 10.85 58 10.84 27.15 30.15 48.46-75.77-35.08-123.38-106.81Q180-310.08 180-400Zm300 9.85 78.08 76.46q15.46 15.46 23.69 34.54Q590-260.08 590-238q0 44.77-32.12 76.38Q525.77-130 480-130q-45.77 0-77.88-31.62Q370-193.23 370-238q0-21.08 8.04-40.46 8.04-19.39 23.88-35.23L480-390.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalFireDepartment24DpFill1Wght300Grad0Opsz24);
export default __webpack_public_path__ + "static/media/local_fire_department_24dp_FILL1_wght300_GRAD0_opsz24.f93b4783336e4562f96e86747cc8a19a.svg";
export { ForwardRef as ReactComponent };